/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

/**
 * @seuha516 need better name for this type
 *
 * e.g.
 *
 * 1. Can be renamed by subject
 * AssistantLog | ToolLog are Logs given from Assistant server
 * SystemLog | UserLog are Logs Client users can send
 *
 * 2. Can add definitions for each suffix
 * what does Log mean? what does Message mean? what does Call mean?
 */

export interface ToolCall {
  id: string;
  type: 'function';
  function: { name: string; arguments: string };

  webSearchSources?: string[]; // only for FE
  codePythonInterpreterFiles?: { name: string; url: string }[]; // only for FE
  errorMessage?: string; // only for FE
}

export interface SystemLog {
  role: 'system';
  content: string;
}
export interface UserLog {
  role: 'user';
  content: string;

  timestamp?: number; // only for FE
}
export interface AssistantLog {
  role: 'assistant';
  content?: string;
  tool_calls?: ToolCall[];

  // only for FE
  modelId?: string;
  stats?: {
    ttft: number | null;
    tpot: number | null;
    tokenPerSecond: number | null;
    outputTokens: number | null;
  };
  firstTokenTimestamp?: number; // only for FE
  lastTokenTimestamp?: number; // only for FE
}
export interface ToolLog {
  role: 'tool';
  content: string;
  tool_call_id: string;
}

export type ChatLog = SystemLog | UserLog | AssistantLog | ToolLog;

export type AiMessage = (AssistantLog | ToolLog)[];
export type Message = UserLog | AiMessage;

export enum InferenceChatTool {
  MathCalculator = 'math:calculator',
  MathStatistics = 'math:statistics',
  MathCalendar = 'math:calendar',

  WebSearch = 'web:search',
  WebUrl = 'web:url',

  CodePythonInterpreter = 'code:python-interpreter',

  FileText = 'file:text',
  // FileImage = 'file:image', TODO: uncomment this after ready
}
